export const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const parseToStreamsetsService = (venueId, data) => {
  const {
    venueName,
    acceptedVehicles,
    driverInstructions,
    internalInstructions,
    booking,
    vehicleRequirements,
    openingHours,
    contacts,
    userId,
  } = data || {};

  return {
    id: venueId?.replace('ontruck:venue:', ''),
    user_id: userId,
    name: venueName,
    addendum_json_accepted_vehicles: (acceptedVehicles || []).length
      ? {
          accepted_vehicles: acceptedVehicles,
        }
      : undefined,
    addendum_json_driver_instructions: driverInstructions
      ? {
          driver_instructions: driverInstructions,
        }
      : undefined,
    addendum_json_other_data: internalInstructions
      ? {
          internal_instructions: internalInstructions,
        }
      : undefined,
    addendum_json_is_booking_required: booking
      ? {
          is_booking_required: booking?.isRequired,
          booking_instructions: booking?.instructions,
        }
      : undefined,
    addendum_json_vehicle_requirements: vehicleRequirements ? vehicleRequirements : undefined,
    addendum_json_contacts: contacts || undefined,
    addendum_json_timeframes: {
      default: parseOpeningHours(openingHours),
      specials: [],
    },
  };
};

const parseToStreamsetsServiceForCreation = (data) => {
  console.log('data', data);
  const {
    venueName,
    venueNameAlternatives,
    acceptedVehicles,
    vehicleRequirements,
    openingHours,
    booking,
    driverInstructions,
    internalInstructions,
    position,
    userId,
    addressId,
  } = data || {};

  return {
    name: venueName,
    user_id: userId,
    name_json: venueNameAlternatives || [],
    source: 'ontruck',
    layer: 'venue',
    popularity: 1,
    category: '',
    lat: Number(position?.lat),
    lon: Number(position?.lng),
    addendum: {
      load_info: {
        source_version: 1,
        source_origin: 'mercury',
      },
      other_data: {
        internal_instructions: internalInstructions,
      },
      accepted_vehicles: {
        accepted_vehicles: acceptedVehicles || [],
      },
      vehicle_requirements: vehicleRequirements || {},
      is_booking_required: {
        is_booking_required: booking?.isRequired,
        booking_instructions: booking?.instructions,
      },
      driver_instructions: {
        driver_instructions: driverInstructions,
      },
      timeframes: {
        default: parseOpeningHours(openingHours),
        specials: [],
      },
      operation_time: {},
      routing_requirements: {},
    },
    address_id: addressId || undefined,
  };
};

const parseOpeningHours = (openingHours = []) => {
  return openingHours.reduce((c, { schedule_days, schedule_ranges }) => {
    const days = schedule_days
      .reduce((current, { selected }, dayIndex) => [...current, selected && dayIndex], [])
      .filter((day) => day !== false)
      .map((dayIndex) => DAYS[dayIndex]);

    const ranges = schedule_ranges
      .map((range) => ({ from: range.from.replace(':', ''), to: range.to.replace(':', '') }))
      .reduce((current, range) => {
        // Detect range overlap
        const fromOverlapIndex = current.findIndex(
          ({ from, to }) => from < range.from && range.from < to
        );
        const toOverlapIndex = current.findIndex(
          ({ from, to }) => from < range.to && range.to < to
        );

        if (fromOverlapIndex < 0 && toOverlapIndex >= 0) {
          current[toOverlapIndex].from = range.from;
          return current;
        }
        if (fromOverlapIndex >= 0 && toOverlapIndex < 0) {
          current[fromOverlapIndex].to = range.to;
          return current;
        }

        // Filter all ranges that overlap with the current one
        const currentFiltered = current.filter(
          ({ from, to }) => from < range.from || to > range.to
        );

        return [...currentFiltered, range];
      }, []);

    // Set the ranges to each selected day
    const result = days.reduce((current, day) => {
      return { ...current, [day]: ranges };
    }, {});
    return { ...c, ...result };
  }, {});
};

export { parseToStreamsetsService, parseToStreamsetsServiceForCreation };
